// Generated from api/openapi/agents.yaml by make docs. Do not edit.
import { z } from "zod";

export const approvalTotalsSchema = z.object({
  "total": z.number().int(),
  "approved": z.number().int(),
  "denied": z.number().int(),
  "expired": z.number().int(),
  "pending": z.number().int()
}).strict();

export const agentApprovalCountSchema = z.object({
  "agent_id": z.string().uuid(),
  "agent_name": z.string().nullable(),
  "total": z.number().int(),
  "approved": z.number().int(),
  "denied": z.number().int()
}).strict();

export const approvalDayCountSchema = z.object({
  "day": z.string().datetime({ offset: true }),
  "approved": z.number().int(),
  "denied": z.number().int(),
  "expired": z.number().int()
}).strict();

export const analyticsWindowSchema = z.object({
  "since": z.string().datetime({ offset: true }),
  "until": z.string().datetime({ offset: true })
}).strict();

export const approvalAnalyticsSchema = z.object({
  "window": analyticsWindowSchema,
  "totals": approvalTotalsSchema,
  "top_agents": z.array(agentApprovalCountSchema),
  "trend": z.array(approvalDayCountSchema)
}).strict();
